import RestaurantStudioAdminPanel from "../AdminPanel/RestaurantStudioAdminPanel";
import {
  createStudioRegistration,
} from "../Studio/StudioRegistration";
/**
 * Déclaration du Restaurant Studio auprès de la plateforme.
 *
 * Cette registration constitue l'unique point de liaison déclaratif entre
 * le domaine Restaurant, le framework Studio et le framework Admin.
 */
export const restaurantStudioRegistration = createStudioRegistration({
  id: "restaurant-studio",
  panelMode: "restaurant_studio",
  loadStudioComponent: () => import(
    "../../pages/restaurant/RestaurantStudio"
  ),
  AdminPanelComponent: RestaurantStudioAdminPanel,
  keyPrefix: "restaurant-studio",
  metadata: {
    domain: "restaurant",
    domainId: "restaurant",
    title: "Restaurant Studio",
    description:
      "Salle / tables / production",
    icon: "🍽️",
    category: "hospitality",
    status: "available",
  },
});

export default restaurantStudioRegistration;
